import React from 'react'
import { Tooltip, useTheme } from '@mui/material'

import { Icon } from '~components/icons/Icon'
import { WhatsAppBubbleIcon } from '~components/icons/WhatsAppBubbleIcon'

import { getInteractionTypeMeta } from '../constants/interactionTypeConstants'

interface InteractionTypeIconProps {
  type: string
  size?: number
  showTooltip?: boolean
  color?: string
}

/**
 * Displays an icon for the AI interaction type with optional tooltip
 */
export const InteractionTypeIcon: React.FC<InteractionTypeIconProps> = ({
  type,
  size = 24,
  showTooltip = true,
  color,
}) => {
  const theme = useTheme()
  const { icon, label } = getInteractionTypeMeta(type)
  const resolvedColor = color ?? theme.palette.text.secondary

  const iconElement =
    icon === 'WhatsApp' ? (
      <WhatsAppBubbleIcon size={size} color={resolvedColor} />
    ) : (
      <Icon name={icon} size={size} color={resolvedColor} />
    )

  if (showTooltip) {
    return (
      <Tooltip title={label} placement='top'>
        <span>{iconElement}</span>
      </Tooltip>
    )
  }

  return iconElement
}
